import { useMemo } from 'react';
import { useAuth } from '../../../components/AuthContext/context';

interface InstanceInfo {
  currentInstanceUid: string | undefined;
  isBefInstance: boolean;
}

export const useCurrentInstanceState = () => {
  const { session } = useAuth();

  const instanceUid: InstanceInfo = useMemo(
    () => ({
      currentInstanceUid: session?.exchange_session?.instance?.uid,
      isBefInstance: session?.exchange_session?.instance?.experience === 'bef',
    }),
    [session]
  );

  return instanceUid;
};
